import React, { FC, PropsWithChildren } from 'react';
import { StatusTag } from '../../common/components/StatusTag';
import { useSystemClassifiers } from '../../configuration/useSystemClassifiers';

export interface AlgorithmStatusProps {
  statusId: number;
}

export const AlgorithmStatus: FC<PropsWithChildren<AlgorithmStatusProps>> = (
  props
) => {
  const { statusId } = props;
  const algorithmStatus =
    useSystemClassifiers('ALGORITHM_STATUS').ALGORITHM_STATUS;
  const status = algorithmStatus.systemClassifierItems.find(
    (item) => item.id === statusId
  );

  if (!status) {
    console.warn(`Algorithm status with ID ${statusId} not found.`);
    return null;
  }

  return <StatusTag status={status.code} />;
};
